// extracted by mini-css-extract-plugin
export default {"licznik":"LicznikCzasu_licznik__qVem6","cyfry":"LicznikCzasu_cyfry__Rm2F0","dopisek":"LicznikCzasu_dopisek__8+aGP"};